import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { AwaitIterators } from '../AnimationHelper';
import { delay } from '../../../Utility/Task/TaskQueue';
import TransformComponent from '../../../Component/Transform';
import { Easing, Tween } from '@tweenjs/tween.js';

export class SurpriseCardShowUp extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const transform = gameObject.getComponent(TransformComponent);

        transform.scale.set(0, 0);
        transform.rotation = 0;

        const scaleTween: Tween = this.getTween(transform.scale);
        scaleTween.to({ x: 1, y: 1 }, 1000).easing(Easing.Back.Out);

        const rotationTween: Tween = this.getTween(transform);
        rotationTween
            .to({ rotation: -Math.PI * 2 }, 500)
            .easing(Easing.Quadratic.Out);

        yield* AwaitIterators([
            this.startTween(scaleTween),
            this.startTween(rotationTween),
        ]);

        transform.rotation = 0;

        while (true) {
            yield* delay(1000);
            yield* this.tweenTo(rotationTween, -0.1, 100);
            yield* this.tweenTo(rotationTween, 0.1, 200);
            yield* this.tweenTo(rotationTween, 0, 100);
        }
    }

    private *tweenTo(
        tween: Tween,
        rotation: number,
        duration: number
    ): IterableIterator<number> {
        tween.to({ rotation: rotation }, duration);
        yield* this.startTween(tween);
    }
}
